import styled from "@emotion/styled";
import { Col } from "antd";

const StyledTenantList = styled(Col)`
  border-left: 1px solid #e5e7eb;
  border-right: 1px solid #e5e7eb;
  padding-inline: 10px;

  .tenant-title {
    margin: 10px 0px;
  }

  .ant-menu {
    height: 100%;
    overflow-y: auto;
    background: transparent;
    border: none !important;
  }

  .ant-menu-item-selected {
    background: linear-gradient(90deg, #7b3bea 0%, #28c665 100%);
    color: #ffffff;
    border-radius: 8px !important;
    font-weight: 500;
  }
  .ant-menu-item {
    border: 1px solid #E5E7EB
  }
`;

export default StyledTenantList;
